import React from "react";

/**
 * SmartImage — renders a <picture> that serves a WebP version of an image
 * (same path, `.webp` extension) with the original PNG/JPG as fallback. The
 * <picture> uses `display: contents` so existing CSS targeting the inner <img>
 * (e.g. `.result-card img`, `.about-image img`) keeps applying unchanged.
 *
 * WebP files are generated by `scripts/optimize-home-images.js`. If a `.webp`
 * is missing, the browser silently falls back to the original `src`.
 *
 * Defaults to lazy loading + async decoding; pass `loading="eager"` for
 * above-the-fold images.
 */
const SmartImage = ({ src, alt = "", className, loading = "lazy", ...rest }) => {
  const webp = src.replace(/\.(png|jpe?g)$/i, ".webp");
  // Filenames contain spaces — encode them for the srcset URL.
  const webpSrcSet = encodeURI(webp);

  return (
    <picture style={{ display: "contents" }}>
      {webp !== src && <source srcSet={webpSrcSet} type="image/webp" />}
      <img
        src={src}
        alt={alt}
        className={className}
        loading={loading}
        decoding="async"
        {...rest}
      />
    </picture>
  );
};

export default SmartImage;
